import * as Yup from 'yup';

const cpfRegex = /^\d{11}$/;

const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
const MAX_FILE_BYTES = 5 * 1024 * 1024;

// Formik trata segmentos numéricos puros (ex: "answers.5") como índice de array.
// Prefixar com "q" mantém as respostas como propriedades de objeto.
export const answerKey = q => `q${q.id}`;

function buildAnswersShape(questions) {
  const shape = {};
  (questions || []).forEach(q => {
    const key = answerKey(q);
    if (q.kind === 'checkbox') {
      let s = Yup.array().of(Yup.string().oneOf(q.options || [], 'Opção inválida'));
      if (q.required) s = s.min(1, 'Selecione ao menos uma opção');
      shape[key] = s;
    } else if (q.kind === 'radio' || q.kind === 'select') {
      let s = Yup.string().oneOf(q.options || [], 'Opção inválida');
      if (q.required) s = s.required('Obrigatório');
      shape[key] = s;
    } else if (q.kind === 'file') {
      let s = Yup.mixed()
        .test('size', 'Arquivo deve ter até 5 MB', f => !f || (f.size != null && f.size <= MAX_FILE_BYTES))
        .test('type', 'Apenas PDF, JPG ou PNG', f => !f || (f.type && ALLOWED_FILE_TYPES.includes(f.type)));
      if (q.required) s = s.required('Obrigatório');
      shape[key] = s;
    } else {
      let s = Yup.string();
      if (q.required) s = s.required('Obrigatório');
      shape[key] = s;
    }
  });
  return Yup.object().shape(shape);
}

export function buildRegistrationSchema(questions = [], targetAudience = 'student', collectEducationInfo = true, collectWorkInfo = true) {
  const studentFields =
    targetAudience === 'student' && collectEducationInfo
      ? {
          current_education_level: Yup.string().oneOf(['fundamental_2', 'medio_1', 'medio_2', 'medio_3', 'concluido', 'outro']).required('Obrigatório'),
          desired_grade: Yup.string().oneOf(['1º Ano EM', '2º Ano EM', '3º Ano EM', 'Outro']).required('Obrigatório'),
          preferred_shift: Yup.string().oneOf(['morning', 'afternoon', 'evening']).required('Obrigatório')
        }
      : {};

  const workplaceRequired = targetAudience === 'student' || collectWorkInfo;
  // Yup.number() casts '' to NaN antes do transform. Usar o original value (segundo arg) p/ mapear '' -> null.
  const emptyToNull = (_curr, orig) => (orig === '' ? null : _curr);
  const workplaceFields = workplaceRequired
    ? {
        regional_id: Yup.number().required('Selecione a regional'),
        institution_id: Yup.number().required('Selecione a unidade')
      }
    : {
        regional_id: Yup.number().transform(emptyToNull).nullable(),
        institution_id: Yup.number().transform(emptyToNull).nullable()
      };

  return Yup.object().shape({
    full_name: Yup.string().trim().min(3, 'Mínimo 3 caracteres').required('Obrigatório'),
    cpf: Yup.string()
      .transform(v => (v || '').replace(/\D/g, ''))
      .matches(cpfRegex, 'CPF inválido')
      .required('Obrigatório'),
    birth_date: Yup.date().max(new Date(), 'Data inválida').required('Obrigatório'),
    email: Yup.string().email('Email inválido').required('Obrigatório'),
    phone: Yup.string()
      .transform(v => (v || '').replace(/\D/g, ''))
      .min(10, 'Telefone inválido')
      .required('Obrigatório'),
    ...workplaceFields,
    ...studentFields,
    special_needs: Yup.boolean(),
    special_needs_description: Yup.string().when('special_needs', {
      is: true,
      then: s => s.required('Descreva as necessidades especiais')
    }),
    lgpd_accepted: Yup.boolean(),
    honeypot: Yup.string(),
    answers: buildAnswersShape(questions)
  });
}
